module.exports = __webpack_public_path__ + "img/7_46.3c32b4d6.png";